import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=2bc22bb8&scoped=true&"
import script from "./nav-bar.vue?vue&type=script&lang=js&"
export * from "./nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./nav-bar.vue?vue&type=style&index=0&id=2bc22bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc22bb8",
  null
  
)

export default component.exports